// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import mixin from '@/globalFunc/mixin' 
import { urlSocket } from '@/var/var.js'

import VueCompositionAPI from '@vue/composition-api'


import VueSocketIO from 'vue-socket.io';
import socketio from "socket.io-client"

const SocketInstance = socketio.connect(urlSocket
/*, {
    query: {
        token: null //window.localStorage.getItem('auth')
    }
}
*/);

Vue.use(new VueSocketIO({
    debug: false,
    connection: SocketInstance
})); // Automaticly socket connect from url string

Vue.use(VueCompositionAPI)

require('@/assets/css/material-dashboard.css')
require('@/assets/demo.css')
 

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
/*
var shared = new Vue({data:{ text: "Dashboard" }})
shared.install = function(){
  Object.defineProperty(Vue.prototype, '$title', {
    get () { return shared }
  })
}
Vue.use(shared);
*/


// WEBPACK FOOTER //
// ./src/main.js